module.exports = __webpack_public_path__ + "static/media/2010s-MIP-devices-icon.b397d7ac.png";